import PoolCard from './PoolCard.container'

export default PoolCard
